export enum SessionFactoryEvent {
    SessionCreated = 0,
    SessionDestroyed = 1,
    SessionFocused = 2,
    ConnectionCreated = 3,
    ConnectionDestroyed = 4,
    ConnectionCreateFailed = 5,
    RedirectionsRequest = 6
}
